import css from 'styled-jsx/css'
import { colors } from '../../styles'

const { textHoverPurple } = colors

export default css`
.PinInput * {
  box-sizing: border-box;
}

label {
  position: absolute;
  visibility: hidden;
}

span {
  display: inline-block;
  font-size: 32px;
  margin: 0 2.5%;
  max-width: 3em;
  width: 20%;
}

input {
  border: solid #b4b4b4;
  border-width: 0 0 6px;
  box-shadow: none;
  font-size: 32px;
  height: 2em;
  text-align: center;
  width: 100%;
}

input:focus {
  border-color: ${textHoverPurple};
  outline: 0;
}
`
